// extracted by mini-css-extract-plugin
module.exports = {"toggle":"pageToggle-module--toggle--6z3Kf","pill":"pageToggle-module--pill--25Fx7","activePill":"pageToggle-module--activePill--OkJdp"};